import { ErrorMessage } from '@components/core-ui/ErrorMessage';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';

import { usePageContext } from '../../providers/PageProvider';
import { ConfidenceHeatmap } from './components/ConfidenceHeatmap';
import { LineHeatmap } from './components/LineHeatmap';
import { Tabs } from './components/Tabs';
import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { isLoading, error, utterances, tab, setTab } = usePageContext();

  return (
    <Wrapper>
      <Tabs tab={tab} setTab={setTab} />
      {isLoading && <LinearProgressLoader active={isLoading} />}
      {error ? <ErrorMessage error={error} /> : null}
      {tab === 'words' && utterances.length > 0 && <ConfidenceHeatmap utterances={utterances} />}
      {tab === 'lines' && utterances.length > 0 && <LineHeatmap utterances={utterances} />}
    </Wrapper>
  );
};
